
import './Header.scss'
import MnDropdown from './components/MnDropdown/MnDropdown.vue'
import MnDropdownItem from './components/MnDropdownItem/MnDropdownItem.vue'
import MnMenu from './components/MnMenu/MnMenu.vue'
import MnTriggerMenu from './components/MnTriggerMenu/MnTriggerMenu.vue'
// import MnSearchPanel from './components/MnSearchPanel/MnSearchPanel.vue'
// import MnSearchOverlay from './components/MnSearchOverlay/MnSearchOverlay.vue'
// import MnRegionSuggestMobile from './components/MnRegion/MnRegionSuggestMobile.vue'
import NavLine from './components/NavLine.vue'
import MnBottomNav from './components/MnBottomNav/MnBottomNav.vue'
import MnBreadcrumbs from './components/MnBreadcrumbs/MnBreadcrumbs.vue'
import MnRegion from './components/MnRegion/MnRegion.vue'
import { isTouchDevice } from './utils/helpers'
import isNewYear from '../../utils/isNewYear'
import { infoCounters } from './data.js'
import overlay from './utils/overlay'
import isEmpty from 'lodash/isEmpty'
import { TEACHER_ITEM_ID } from './consts.js'
import { getCookie } from '../../utils/cookies'
import {
  getUnreadNoticesCount,
  getEventsCount,
  getCurrentLocation,
  getChatUnreadMessageCount,
  tryAuth
} from '../utils/api'
import Modal from '../../utils/modal/modal'
import io from 'socket.io-client'
import Notify from './utils/notification'
import FaviconNotify from 'favicon-notify'
import { store } from '../../store'
import GbAppButton from '../../components/AppButton/AppButton.vue'
import CalendarWidget from '../../elements/Schedule/components/CalendarWidget/CalendarWidget.vue'
import clickOutside from '../../directives/clickOutside/vClickOutsude'
import Helpers from '../../utils/helpers'
import { gbLocalStorage } from '../../utils/storage'
import moment from 'moment'
import GbAvatar from '../../components/Avatar/Avatar.vue'

const line = 'line'
const teacherLine = 'teacher-line'
const profile = 'profile'
const lineSec = 'line_second'
const chatUrl = '/comms/chat'
const calendarUrl = '/comms/calendar'
const chatWsURL = 'wss://ws.geekbrains.ru/chat'
const LSChatMessageCount = 'chatMessageCount'

export default {
  name: 'GbHeader',
  store,
  components: {
    GbAvatar,
    GbAppButton,
    MnDropdown,
    MnDropdownItem,
    MnMenu,
    MnTriggerMenu,
    // MnSearchPanel,
    // MnSearchOverlay,
    // MnRegionSuggestMobile,
    NavLine,
    MnBottomNav,
    MnBreadcrumbs,
    MnRegion,
    CalendarWidget
  },

  directives: { clickOutside },
  props: {
    data: {
      type: Array,
      default: () => []
    },

    listBreadcrumbs: {
      type: Array,
      default: () => []
    },

    breadCrumbsPages: {
      type: Array,
      default: null
    },

    /* TODO: Временное решение, пока не согласовано с беком. Эти данные пока достаем отдельно.
        В будущем будет реализована логика через data */
    isAuth: {
      type: Boolean,
      default: false
    },

    userInfo: {
      type: Object,
      default: () => null
    },

    isDarkTheme: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isTeacherPage: false,
      isOpenedMenu: false,
      infoCounters,
      isVisibleSearch: false,
      isWindowScrolled: false,
      isTouchDevice: false,
      isAuthLocal: this.isAuth,
      modal: null,
      io: null,
      jwt: null,
      chatUrl,
      calendarUrl,
      notifyAvailable: null,
      notification: null,
      faviconNotify: null,
      // cartCountItems: 0,
      locationInfo: null,
      currencyId: null,
      isCalendarWidgetShow: false,
      isShowReferral: false
    }
  },

  computed: {
    isNewYearBanners() {
      return isNewYear()
    },

    lineMenu() {
      const items = this.getMenu(line, this.data)

      if (!items) return []

      return items
    },

    teacherLineMenu() {
      const items = this.getMenu(teacherLine, this.data)

      if (!items) return []

      return items.filter(item => item.id !== TEACHER_ITEM_ID)
    },

    burgerMenu() {
      if (this.isTeacherPage) {
        const items = this.getMenu('teacher-burger', this.data)

        return !items ? this.getMenu('burger', this.data) : items
      }

      return this.getMenu('burger', this.data)
    },

    profileMenu() {
      const menus = this.getMenu(profile, this.data)

      if (isEmpty(menus)) return []

      const firstMatchIndex = menus.findIndex(item => item.group)

      if (firstMatchIndex && menus[firstMatchIndex]) {
        menus[firstMatchIndex].border = 'top'
      }

      let lastMatchIndex = 0
      menus.forEach((item, index) => {
        if (item.group) {
          lastMatchIndex = index
        }
      })

      menus[lastMatchIndex].border = 'bottom'

      return menus
    },

    lineSecondMenu() {
      const lineSecond = this.getMenu(lineSec, this.data)

      if (!lineSecond) return []

      return lineSecond
    },

    userBoxButtonData() {
      const [buttonData] = this.getMenu('button', this.data) || []

      return buttonData || { title: '', url: '/' }
    }
  },

  watch: {
    isAuth(isAuth) {
      this.isAuthLocal = isAuth
    },

    $route() {
      this.checkTeacherPage('route')
    }
  },

  created() {
    if (this.$route) {
      this.checkTeacherPage('route')
    }
  },

  beforeMount() {
    Helpers.checkWindowExists(() => {
      this.checkTeacherPage()
    })
  },

  async mounted() {
    this.jwt = getCookie('jwt_token') || null

    if (!this.jwt) {
      try {
        await tryAuth()
        this.jwt = getCookie('jwt_token') || null
        Helpers.checkWindowExists(() => {
          if (this.jwt) {
            window.location.reload()
          }
        })
      } catch (e) {}
    }

    this.isShowReferral = !gbLocalStorage.get('hide-referral')

    Helpers.checkWindowExists(() => {
      if (window.location.pathname.includes('teacher')) {
        document.getElementById('header-monolit').classList.add('shortened-height')
      }
    })

    if (process.env.NODE_ENV === 'production') {
      const script = document.createElement('script')
      script.src = 'https://gb.ru/channels/assets/js/utm_3.min.js'
      document.getElementsByTagName('head')[0].appendChild(script)
    }

    this.notifyAvailable = 'Notification' in window

    // const orderRef = getCookie('cartRef')
    // const orderAccessToken = getCookie('cartAccessToken')

    await this.fetchNoticeCount()

    const hasUser = !!this.jwt

    Helpers.checkWindowExists(async () => {
      if (hasUser) {
        try {
          await this.updateUserEventsStorage()
        } catch (e) {
          console.error(e)
        }
      } else {
        this.infoCounters.events = 0
      }
    })

    // try {
    //   this.cartCountItems = hasUser
    //     ? await getItemsCart(orderRef, orderAccessToken).then(
    //       ({ data }) => data?.items_count || 0
    //     )
    //     : 0
    // } catch (e) {
    //   console.error(e)
    // }

    window.addEventListener('footer-received-location-data', e => {
      e.stopImmediatePropagation()
      this.$store.commit('setFooterReceivedData', true)
    })

    try {
      this.locationInfo = await getCurrentLocation()

      const isPathnameIncludes = array => {
        return Helpers.checkWindowExists(() => {
          const pathnameArray = window.location.pathname.split('/')
          if (Array.isArray(pathnameArray) && pathnameArray.length >= 2) {
            return array.includes(pathnameArray[1])
          }

          return false
        })
      }

      const defineRegionEnabled = this.locationInfo.data?.data?.defineRegionEnabled || false
      const allowedPages = [
        '',
        'posts',
        'topics',
        'blog',
        'career',
        'company',
        'faq',
        'tests',
        'users',
        'teacher',
        'feedbacks',
        'events'
      ]
      const isSuggestVisibleOnPage = isPathnameIncludes(allowedPages)

      if (this.locationInfo) {
        this.$store.commit('setNeedToEmitRegion', true)
        this.$store.commit('setLocation', this.locationInfo.data.data.location)
        this.$store.commit('setDefineRegion', defineRegionEnabled)
      }

      if (isSuggestVisibleOnPage && defineRegionEnabled) {
        const message = this.locationInfo.data.data.content.message

        if (message) {
          this.$store.commit('setSuggestionMessage', message)
          this.$store.commit('setSuggestVisible', true)
        }
      }
    } catch (e) {
      console.error(e)
    }

    try {
      const currencyFromCookie = this.$store.getters.getCurrencyId
      if (currencyFromCookie) {
        this.currencyId = currencyFromCookie
      } else {
        if (this.$store.state.regionsWithCurrencies.length < 1) {
          await this.getRegionsWithCurrencies()
        }
        this.currencyId = this.$store.getters.getCurrencyIdForLocation(
          this.$store.state.location?.id
        )
      }
      this.$store.commit('setNeedToEmitCurrency', true)
      this.$store.commit('setCurrency', this.currencyId)
    } catch (e) {
      console.error(e)
    }

    this.isAuthLocal = this.isAuth ? this.isAuth : !!getCookie('jwt_token')
    this.isTouchDevice = isTouchDevice()
    this.modal = new Modal()

    if (this.$refs.header?.classList.contains('mn-header-fixed')) {
      document.body.style.paddingTop = `${this.$refs.header.clientHeight}px`
    }

    this.handleScroll()
    window.addEventListener('scroll', this.handleScroll)

    Array.from(document.getElementsByTagName('link'))
      .find(item => item.type === 'image/x-icon')
      ?.remove()
    this.faviconNotify = new FaviconNotify({
      fontFamily: 'Onest',
      fontVOffset: 1,
      labelOffset: 7,
      withCounter: true
    })
    this.notifyAvailable && (this.notification = new Notify())

    const handlerChatNotify = count => {
      count ? this.faviconNotify.setCounter(+count) : this.faviconNotify.remove()
      this.infoCounters.messages = +count
    }

    window.addEventListener('storage', ({ key, newValue }) => {
      if (key === LSChatMessageCount) {
        handlerChatNotify(newValue)
      }
    })

    const getChatMessageCount = () => {
      getChatUnreadMessageCount().then(({ data }) => {
        handlerChatNotify(data.count)
        window.localStorage.setItem(LSChatMessageCount, data.count)
      })
    }
    const createIO = () => {
      this.io = this.startIO()

      this.io.on('connect', () => {
        getChatMessageCount()
      })

      this.io.on('message', ({ data }) => {
        this.notifyAvailable &&
          this.notification.spawnNotification(`${data.author}: ${data.text}`, data.avatar)

        getChatMessageCount()
      })
    }

    if (this.jwt && this.isAuthLocal) {
      createIO()
    }

    this.modal.onClose(() => {
      setTimeout(() => {
        !this.io.connected && createIO()
      }, 500)
    })

    window.addEventListener('gb-region-changed-from', e => {
      e.stopImmediatePropagation()
      if (e.detail?.locationId) {
        this.$store.commit('setSuggestVisible', false)
        this.$store.commit('setNeedToEmitRegion', false)
        this.$store.dispatch('setSelectedLocation', {
          id: e.detail.locationId.toUpperCase(),
          setEmit: true
        })
      }
    })

    window.addEventListener('gb-currency-changed-from', e => {
      e.stopImmediatePropagation()
      if (e.detail?.currencyId) {
        this.$store.commit('setNeedToEmitCurrency', false)
        this.$store.commit('setCurrency', e.detail.currencyId.toLowerCase())
        this.$store.commit('setNeedToEmitCurrency', true)
      }
    })

    window.addEventListener('gb-overlay-closed', e => {
      e.stopImmediatePropagation()
      document.body.classList.remove('burger-open')
      overlay.remove()
      this.isOpenedMenu = false
    })

    window.addEventListener('resize', this.checkCalendarWidgetShow)

    window.addEventListener('gb-all-notice-read', this.fetchNoticeCount)
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.checkCalendarWidgetShow)
    window.removeEventListener('gb-all-notice-read', this.fetchNoticeCount)
  },

  methods: {
    async fetchNoticeCount() {
      try {
        this.infoCounters.notifications = this.jwt
          ? await getUnreadNoticesCount().then(({ data }) => data)
          : 0
      } catch (e) {
        console.error(e)
      }
    },

    checkTeacherPage(isRoute = null) {
      if (isRoute) {
        this.isTeacherPage =
          this.$route.path.includes('/teacher') && !this.$route.path.includes('/users/teacher')
      } else {
        this.isTeacherPage =
          window.location.href.includes('/teacher') &&
          !window.location.href.includes('/users/teacher')
      }
    },

    checkCalendarWidgetShow() {
      if (window.innerWidth < 768 && this.isCalendarWidgetShow) this.closeCalendarWidget()
    },

    getMenu(type, menuData) {
      if (isEmpty(menuData)) {
        return []
      }

      return menuData.find(item => item.type === type)?.items
    },

    onTriggerMenu() {
      if (this.isOpenedMenu) {
        this.closeMenu()
      } else {
        this.openMenu()
      }
    },

    openMenu() {
      if (!this.isOpenedMenu) {
        this.isOpenedMenu = true
        overlay.append()
        document.body.classList.add('burger-open')
      }
    },

    closeMenu() {
      if (this.isOpenedMenu) {
        this.isOpenedMenu = false
        document.body.classList.remove('burger-open')
        overlay.remove()
      }
    },

    /* TODO временно закомментировано в рамках https://youtrack.admin.geekbrains.ru/issue/GBF-984/Obnovit-kheder
    если действительно поиск больше будет не нужен, то необходимо удалить MnSearchOverlay & MnSearchPanel */

    // setBodyStyleOverflow(overflow) {
    //   document.body.style.overflow = overflow
    // },

    // onVisibleSearch(isVisible) {
    //   const searchBtn = document.querySelector('.js-search-button')
    //   if (searchBtn) {
    //     searchBtn.click()
    //   } else {
    //     this.isVisibleSearch = isVisible
    //     const bodyOverflow = isVisible ? 'hidden' : 'unset'
    //     this.setBodyStyleOverflow(bodyOverflow)
    //   }
    // },

    handleScroll() {
      this.isWindowScrolled = window.scrollY > 0
    },

    async showWidget(src, withOffsets = false) {
      if (src === chatUrl && this.io.connected) {
        this.notifyAvailable && (await this.notification.requestPermission())
        this.io.close()
      }
      const iframe = document.createElement('iframe')
      iframe.setAttribute('src', src)
      this.modal.open(iframe, withOffsets)
    },

    toggleCalendarWidget() {
      this.updateUserEventsStorage(true)
      this.isCalendarWidgetShow = !this.isCalendarWidgetShow
    },

    async updateUserEventsStorage(isResetCounter = false) {
      const USER_EVENTS_KEY = 'user-events'
      const today = moment().format('YYYY-MM-DD')
      const userEvents = gbLocalStorage.get(USER_EVENTS_KEY) || null
      const noActiveUserEvents = !userEvents || userEvents.date !== today
      const isCalendarPage = window.location.pathname.includes('calendar')

      if (isResetCounter || isCalendarPage) {
        if (userEvents) userEvents.count = 0
        if (this.infoCounters.events) this.infoCounters.events = 0
      } else if (noActiveUserEvents) {
        try {
          this.infoCounters.events = await getEventsCount(today)
        } catch (e) {
          console.error(e)
        }
      }

      gbLocalStorage.set(USER_EVENTS_KEY, {
        date: today,
        count: this.infoCounters.events
      })
    },

    closeCalendarWidget() {
      if (this.isCalendarWidgetShow) this.isCalendarWidgetShow = false
    },

    startIO() {
      return io(chatWsURL, {
        transports: ['websocket'],
        reconnection: true,
        reconnectionAttempts: Infinity,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 5000,
        query: {
          jwt_token: this.jwt
        }
      })
    },

    async getRegionsWithCurrencies() {
      await this.$store.dispatch('getRegionsWithCurrencies')
    }
  }
}
